import React from "react";

const Loader = () => {
    return(
        <div className="Loader-Div">
            <span className="loader"></span>
        </div>
    )
}

export default Loader;